var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolicEeye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1061)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5134 62.1469C59.6732 62.1469 75 44.2192 75 38.6304C75 33.0147 59.6451 15.1152 37.5134 15.1152C15.5196 15.1152 0 33.0147 0 38.6304C0 44.2192 15.6308 62.1469 37.5134 62.1469ZM37.5134 54.0402C28.8817 54.0402 22.0768 47.0411 22.0219 38.6304C21.9938 30 28.8817 23.2232 37.5134 23.2232C46.0902 23.2232 52.9781 30 52.9781 38.6317C52.9781 47.0424 46.0902 54.0415 37.5134 54.0415M37.5134 44.1924C40.5844 44.1924 43.1304 41.6745 43.1304 38.6317C43.1304 35.5607 40.5857 33.0442 37.5134 33.0442C34.4156 33.0442 31.8696 35.562 31.8696 38.6317C31.8696 41.6759 34.4143 44.1924 37.5134 44.1924Z",
    fill: "url(#paint0_linear_1_1061)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1061",
    x: -4,
    y: 15.1152,
    width: 83,
    height: 55.0317,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1061"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1061",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1061",
    x1: 37.5,
    y1: 15.1152,
    x2: 37.5,
    y2: 62.1469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20AC95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018563"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicEeye);
export default __webpack_public_path__ + "static/media/PolicEeye.53b4eba731780330865331b120cea846.svg";
export { ForwardRef as ReactComponent };